/* [BD] Featured collection tabs — bd-featured-collection.liquid */
;(function () {
  function initBdFeaturedCollection(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-bd-featured-collection]').forEach(function (section) {
      if (section.dataset.bdFcInit === '1') return;
      section.dataset.bdFcInit = '1';
      section.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-bd-fc-tab]');
        if (!tab || !section.contains(tab)) return;
        var id = tab.getAttribute('data-bd-fc-tab');
        if (!id) return;
        var tabs = section.querySelectorAll('[data-bd-fc-tab]');
        var panels = section.querySelectorAll('[data-bd-fc-panel]');
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-bd-fc-tab') === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-bd-fc-panel') === id;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-hidden', on ? 'false' : 'true');
          if ('inert' in p) {
            p.inert = !on;
          } else if (on) {
            p.removeAttribute('inert');
          } else {
            p.setAttribute('inert', '');
          }
        });
      });
    });
  }

  function boot(scope) {
    initBdFeaturedCollection(scope || document);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionFeaturedCollectionDesignMode) {
    window.__bdSectionFeaturedCollectionDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
  }
})();
